import Geolocation from '@react-native-community/geolocation';
const GeolocationUtils = {
    requestPermission() {
        return new Promise((resolve, reject) => {
            Geolocation.requestAuthorization(() => {
                resolve();
            }, error => {
                reject(error);
            });
        });
    },
    getCurrentPosition() {
        return new Promise((resolve, reject) => {
            Geolocation.getCurrentPosition(success => {
                resolve(success);
            }, error => {
                reject(error);
            });
        });
    },
};
export default GeolocationUtils;
